import { useEffect, useState } from 'react';
import { storageService } from 'framework/utils';
import { EmployeeType, useEmployeeSuggestionsService } from 'domain/shared/employee';

const STORAGE_KEY = 'staffing-coordinators-dashboard';
const VERSION = '1.1';

const useStaffingCoordinatorsService = () => {
  const [employees, setEmployees] = useState<
    {
      name: string;
      alias: string;
    }[]
  >([]);
  const { searchAll } = useEmployeeSuggestionsService();

  const getStaffingCoordinators = async () => {
    const availableEmployees = (await searchAll({
      filter: {
        'specification:isStaffingCoordinator': {
          eq: true,
        },
      },
    })) as unknown as EmployeeType[];

    return [
      ...availableEmployees.map((employee: EmployeeType) => {
        return {
          name: `${employee?.nameEn?.firstName} ${employee?.nameEn?.lastName}`,
          alias: employee.alias,
        };
      }),
    ];
  };

  const { getDataFromStorage } = storageService(STORAGE_KEY, getStaffingCoordinators, VERSION);

  useEffect(() => {
    getDataFromStorage().then(storageParameters => setEmployees(storageParameters || []));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { employees };
};

export default useStaffingCoordinatorsService;
